export class UpdateAssetName {
    assetId: number;
    name: string;
    dictionaryItemId: number;
    // uomNew: string;
    // dimensionNew: string;
}